function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.regexp.flags.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import React from 'react';
import { CountryFlag } from "../../../countries";
import { Dropdown } from '@isyc-react/design/overlays';
import { getCountryCallingCode } from 'libphonenumber-js/max';
import clsx from 'clsx';
import AutosizeInput from 'react-18-input-autosize';
import { OverlayContainer, OverlayOption, OverlaySearch } from "../../../base";
import { usePhoneCountries } from "../base";
import '@isyc-react/design/main';
import "./input-phone.style.scss";
export const InputPhoneCountry = props => {
  const {
    country,
    value,
    onChange,
    readOnly,
    disabled,
    flags,
    onlyCountries,
    excludeCountries,
    containerRef,
    dataTestId
  } = props;
  const [show, setShow] = React.useState(false);
  const [prefix, setPrefix] = React.useState(getCountryCallingCode(country));
  React.useEffect(() => {
    setPrefix(getCountryCallingCode(country));
  }, [country]);
  const {
    search,
    onSearch,
    cc,
    ccFromCallingCode
  } = usePhoneCountries(onlyCountries, excludeCountries);
  return /*#__PURE__*/React.createElement("div", {
    className: "phone-country"
  }, /*#__PURE__*/React.createElement(Dropdown, {
    alignEnd: false,
    show: show,
    onToggle: nextShow => setShow(nextShow),
    drop: 'down'
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, null, (toggleProps, meta) => {
    var _ref;
    return /*#__PURE__*/React.createElement("div", {
      className: "phone-value"
    }, flags && /*#__PURE__*/React.createElement("div", _extends({}, toggleProps, {
      onClick: () => {
        if (!disabled && !readOnly) meta.toggle(!show);
      },
      tabIndex: 0,
      className: "me-3"
    }), /*#__PURE__*/React.createElement(CountryFlag, {
      alpha2: country,
      className: "phone-flag font-size-16 rounded"
    })), /*#__PURE__*/React.createElement("div", {
      className: clsx('phone-prefix', {
        'empty-number': !value
      })
    }, /*#__PURE__*/React.createElement("span", {
      className: "me-1"
    }, "+"), /*#__PURE__*/React.createElement(AutosizeInput, {
      "data-test-id": dataTestId,
      className: "input-prefix-container",
      inputClassName: "input-prefix",
      value: (_ref = prefix) !== null && _ref !== void 0 ? _ref : '',
      readOnly: readOnly,
      disabled: disabled,
      maxLength: 4,
      onChange: e => {
        const prefixValue = e.target.value;
        const countryCode = ccFromCallingCode(prefixValue);
        if (countryCode && onChange) onChange(countryCode);
        setPrefix(prefixValue);
      },
      onBlur: () => {
        setPrefix(getCountryCallingCode(country));
      }
    })));
  }), /*#__PURE__*/React.createElement(Dropdown.Menu, {
    flip: false,
    offset: [-16, 18]
  }, (menuProps, meta) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(OverlayContainer, _extends({}, menuProps, {
    autoWidth: {
      reference: containerRef
    },
    show: meta.show
  }), /*#__PURE__*/React.createElement(OverlaySearch, {
    value: search,
    onChange: onSearch,
    onClear: () => onSearch('')
  }), cc.map((cc, i) => /*#__PURE__*/React.createElement(OverlayOption, {
    selected: country === cc.alpha2,
    key: i,
    onClick: () => {
      onChange && onChange(cc.alpha2);
      meta.toggle && meta.toggle(!show);
    }
  }, /*#__PURE__*/React.createElement(CountryFlag, {
    alpha2: cc.alpha2,
    className: "me-3 font-size-16 rounded"
  }), /*#__PURE__*/React.createElement("div", {
    className: "me-2"
  }, cc.name), /*#__PURE__*/React.createElement("div", {
    className: "fw-bold text-muted"
  }, "+", cc.code))))))));
};